/* ============================================================================
   nuud US — cart drawer
   ----------------------------------------------------------------------------
   Adding to cart slides the drawer out instead of navigating away.

   The drawer never rebuilds its own markup. After every change it asks Shopify
   to re-render the section (`/?sections=cart-drawer`) and swaps the HTML in, so
   prices, discounts and selling-plan names always come from Liquid and cannot
   drift from the cart's real state.

   Everything degrades: with this file absent the buy-box form still posts to
   /cart/add and the /cart page still works.
   ========================================================================= */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';

  function el() { return document.querySelector('[data-cart-drawer]'); }

  /* ------------------------------------------------------------------ open */
  var lastFocus = null;

  function open() {
    var d = el(); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var close = d.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function close() {
    var d = el(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* --------------------------------------------------------------- refresh */
  function refresh() {
    return fetch('/?sections=' + SECTION, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (!html) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer]');
        var current = el();
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) {
            current.classList.add('is-open');
            current.setAttribute('aria-hidden', 'false');
          }
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = String(cart.item_count);
        });
      });
  }

  /* ------------------------------------------------------------ mutations */
  function changeLine(key, quantity) {
    setBusy(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refresh).finally(function () { setBusy(false); });
  }

  function setBusy(state) {
    var d = el(); if (d) d.classList.toggle('is-busy', !!state);
  }

  function addToCart(form) {
    setBusy(true);
    return fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          // Sold out, or a selling plan that no longer exists. Say so rather
          // than opening an empty-looking drawer.
          window.alert(res.body.description || res.body.message || 'Could not add to cart.');
          return;
        }
        /* Straight to checkout, or open the drawer, depending on what the
           form asks for.

           This shop sells one cream in three packs, and the picker above the
           button already settles pack, subscribe-or-not and frequency. The
           drawer then restated that choice and asked for a second click. There
           is no basket to build, so `data-after-add="checkout"` skips it.

           Verified before switching: the selling plan survives /cart/add.js
           (the line comes back with recurring: true and the subscribed price),
           and Shopify's checkout shows the cadence on the line item — so
           nothing about the subscription is confirmed only in the drawer.

           The drawer is still reachable from the cart link, and still used by
           any form that does not ask for checkout. */
        if (form.getAttribute('data-after-add') === 'checkout') {
          window.location.href = '/checkout';
          return;
        }
        return refresh().then(open);
      })
      .finally(function () { setBusy(false); });
  }

  /* ---------------------------------------------------------------- events */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { close(); return; }
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refresh().then(open); return; }

    var line = e.target.closest('[data-line-key]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var input = line.querySelector('[data-qty]');

    if (e.target.closest('[data-line-remove]')) { changeLine(key, 0); return; }
    if (e.target.closest('[data-qty-down]')) {
      changeLine(key, Math.max(0, (parseInt(input.value, 10) || 1) - 1)); return;
    }
    if (e.target.closest('[data-qty-up]')) {
      changeLine(key, (parseInt(input.value, 10) || 0) + 1); return;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty]');
    if (!input) return;
    var line = input.closest('[data-line-key]');
    if (line) changeLine(line.getAttribute('data-line-key'), parseInt(input.value, 10) || 0);
  });

  // The buy box posts normally without JS; with JS it goes through the drawer.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-buy-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.nuudCart = { open: open, close: close, refresh: refresh };
})();
